import $ from 'jquery';

const $list = $('.project-list');

$(function () {
    if ($list.length > 0) {
        $list.each(function () {
            projectList($(this));
        });
    }
});

const projectList = (listEl) => {
    const filter = {
        page: 1,
        search: '',
        region: -1,
        target: -1,
    };

    bindProjectLoadMore(listEl, filter);
    bindProjectFilter(listEl, filter);
};

const reRenderList = async (element, filter, loadMore = false) => {
    const data = await getProjects(filter);
    if(loadMore){
        element.find('.project-list__grid').append(data.html);
    } else {
        element.find('.project-list__grid').html(data.html);
    }
    element.find('.project-list__show-more').html(data.loadMore);
};

const bindProjectFilter = (element, filter) => {
    element.on('change', '.select__target', function () {
        filter.page = 1;
        filter.target = parseInt($(this).val());        

        reRenderList(element, filter);
    });

    element.on('change', '.select__region', function () {
        filter.page = 1;
        filter.region = parseInt($(this).val());        

        reRenderList(element, filter);
    });

    element.on('keyup', "input[name='project-list-input-search']", function (e) {        
        delay(function () {
            filter.page = 1;
            filter.search = element.find("input[name='project-list-input-search']").val();
            reRenderList(element, filter);
        }, 400);
    });
    
};

const bindProjectLoadMore = (element, filter) => {
    element.on('click', '.project-list__show-more-button', function () {
        filter.page++;
        reRenderList(element, filter, true);
    })
}


const getProjects = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/opzp/v1/project/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};

const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();